export enum AuthVia {
  MedmasteryApp = 'medmastery-app',
}

export enum AuthViaStorageKey {
  AuthVia = 'mm_auth_via',
}

export type UserRole = 'member' | 'professional' | 'Group manager' | 'Group owner' | 'Group member';

export enum SubscriptionType {
  trial = 'trial',
  basic = 'basic',
  pro = 'pro',
}